import { defineMessages } from 'react-intl';

const translations = {
  emptyMessage: {
    id: 'pages.shipments.emptyMessage',
    defaultMessage: 'No shipments',
    description: 'Empty message of the data list on the shipments page',
  },
  actions: {
    pick: {
      id: 'pages.shipments.actions.pick',
      defaultMessage: 'Pick',
      description: 'Label of the pick bulk action on the shipments page',
    },
  },
  properties: {
    inbound: {
      id: 'properties.inbound',
      defaultMessage: 'Inbound',
      description: 'Label of the inbound property',
    },
    outbound: {
      id: 'properties.outbound',
      defaultMessage: 'Outbound',
      description: 'Label of the outbound property',
    },
  },
  feedback: {
    noCancelledShipments: {
      id: 'pages.shipments.feedback.noCancelledShipments',
      defaultMessage:
        'Picklist could not be created. Some of the selected shipments are cancelled.',
      description: 'Error message for creating a multi-shipment picklist on the shipments page',
    },
    picklistNotCreated: {
      id: 'pages.shipments.feedback.picklistNotCreated',
      defaultMessage:
        'Picklist could not be created. You can only select shipments which are not on any picklist.',
      description: 'Error message for creating a multi-shipment picklist on the shipments page',
    },
    shipmentsNotAllEqualIsOutbound: {
      id: 'pages.shipments.feedback.shipmentsNotAllEqualIsOutbound',
      defaultMessage: 'Picklist could not be created. Not all shipments are {prop}.',
      description: 'Error message for creating a multi-shipment picklist on the shipments page',
    },
    shipmentsNotAllEqualLocation: {
      id: 'pages.shipments.feedback.shipmentsNotAllEqualLocation',
      defaultMessage:
        'Picklist could not be created. Not all shipments are coming from or going to location {location}.',
      description: 'Error message for creating a multi-shipment picklist on the shipments page',
    },
    shipmentCanNotBePicked: {
      id: 'pages.shipments.feedback.shipmentCanNotBePicked',
      defaultMessage: 'Shipment could not be picked',
      description: 'Error message for picking a shipment on the shipments page',
    },
    shipmentCanNotBePlaced: {
      id: 'pages.shipments.feedback.shipmentCanNotBePlaced',
      defaultMessage: 'Shipment could not be placed',
      description: 'Error message for placing a shipment on the shipments page',
    },
    shipmentNotFound: {
      id: 'pages.shipments.feedback.shipmentNotFound',
      defaultMessage: 'Shipment could not be found',
      description: 'Error message for scanning a shipment on the shipments page',
    },
  },
};

export default defineMessages(translations);
